// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { ExamInformation } from '../../types/Model';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface ExamInformationState {
  examInformation: Record<number, ExamInformation>;
  isLoading: boolean;
  isInformationFetching: boolean;
  isBuying: boolean;
  isEnding: boolean;
  error?: Error;
}

const { getExamInformationActions, buyExamActions, endExamActions } = actionCreatorsList;

export const initialState: ExamInformationState = {
  examInformation: {},
  isLoading: false,
  isInformationFetching: false,
  isBuying: false,
  isEnding: false,
};

export default function (state = initialState, action: RootAction):ExamInformationState {
  let newState = state;
  switch (action.type) {
    // getExamInformationActions
    case getType(getExamInformationActions.request): {
      newState = {
        ...state,
        isInformationFetching: !action.payload.preventLoading,
        error: undefined,
      };
      break;
    }
    case getType(getExamInformationActions.success): {
      const { payload } = action;
      const exam = payload.examInformation;
      newState = {
        ...state,
        isInformationFetching: false,
        examInformation: { ...state.examInformation, [exam.id]: exam },
      };
      break;
    }
    case getType(getExamInformationActions.failure): {
      newState = {
        ...state,
        isInformationFetching: false,
        error: action.payload.error,
      };
      break;
    }
    // buyExamActions
    case getType(buyExamActions.request): {
      newState = {
        ...state,
        isBuying: true,
      };
      break;
    }
    case getType(buyExamActions.success): {
      newState = {
        ...state,
        isBuying: false,
      };
      break;
    }
    case getType(buyExamActions.failure): {
      newState = {
        ...state,
        isBuying: false,
      };
      break;
    }
    // endExamActions
    case getType(endExamActions.request): {
      newState = {
        ...state,
        isEnding: true,
      };
      break;
    }
    case getType(endExamActions.success): {
      newState = {
        ...state,
        isEnding: false,
      };
      break;
    }
    case getType(endExamActions.failure): {
      newState = {
        ...state,
        isEnding: false,
      };
      break;
    }
  }

  if (newState !== state) {
    newState = {
      ...newState,
      isLoading: newState.isInformationFetching || newState.isBuying
    }
  }

  return newState;
}
